<div
  [ngStyle]="{ backgroundImage: 'url(' + background + ')' }"
  [ngClass]="classes"
  baseImageFallback
  [isCompany]="isCompany"
></div>
